module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-434.8368d1b.woff2";